import React from "react";
import { Link } from "react-router-dom";
import './LandingCard.css';

const LandingCard = ( props ) => {

  const handleClickCard = ( event ) => {
    if ( props.disabled ) {
      event?.preventDefault();
      return;
    }

    if ( !props?.disabled && props?.onClick ) {
      props?.onClick();
    }
  };

  const linkTarget = props.disabled ? "#" : ( props.url ? props.url : "#" );

  return (
    <Link
      to={ linkTarget }
      style={ {
        textDecoration: "none",
        color: "#000",
        fontWeight: "700",
        fontSize: "17px",
        pointerEvents: props.disabled ? "none" : "auto",
        cursor: props.disabled ? "not-allowed" : "pointer",
      } }
      onClick={ handleClickCard }
    >
      <div
        className={ `card-div ${ props.className }` }
        style={ {
          border: props?.disabled ? "1px solid #bcbcbc" : "2px solid #000000",
          backgroundImage: props.image ? `url(${ props.image })` : undefined,
          backgroundSize: props.image ? "cover" : undefined,
          backgroundPosition: props.image ? "center" : undefined,
        } }
      >
        { props.description ? (
          <div className="card-copy">
            <p style={ {
              color: props?.disabled ? "#bcbcbc" : props.color ? props.color : "#000000",
            } }>{ props.title }</p>
            <span className="card-description">{ props.description }</span>
          </div>
        ) : (
          <p style={ {
            color: props?.disabled ? "#bcbcbc" : props.color ? props.color : "#000000",
            maxWidth: props.appCode === 'SSA' ? '100px' : ''
          } }>{ props.title }</p>
        ) }
      </div>
    </Link>
  );
};

export default LandingCard;
